import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import arrow_left from "../../images/arrow-left.png";
import { RootState } from '../store';
import { setwizardPageNumber } from '../authslice';
import { useDispatch, useSelector } from 'react-redux';

function BackButtonResetPassword(props: any) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const page = useSelector((state: RootState) => state.resetPassword.wizardPageNumber);

  const handleBack = () => {
    if ((page - 1) === 0) {
      navigate("/onboardingLoginAccount");
      window.location.reload();
    }
    dispatch(setwizardPageNumber(page - 1));
  };

  return (
    <span onClick={handleBack} role='button'>
      <img src={arrow_left} width={23} alt="Back Arrow" />
      <span className="fw-bold small ms-2">{t('common.back')}</span>
    </span>
  );
}

export default BackButtonResetPassword;
